import styled from 'styled-components'

const MainButton = ({
  label,
  onClick,
  secondary = false,
}: {
  label: string
  onClick: () => void
  secondary?: boolean
}) => {
  return (
    <MainButtonContainer
      style={{
        backgroundColor: secondary ? 'var(--yellow-main)' : undefined,
        color: secondary ? 'var(--brandblue-main)' : undefined,
      }}
      onClick={onClick}
    >
      {label}
    </MainButtonContainer>
  )
}
const MainButtonContainer = styled.button`
  background-color: var(--yellow-main);
  padding: 30px 15px;
  min-width: 150px;
  text-align: center;
  border-radius: 30px;
  padding: 10px 20px;
  border: 0;
  font-family: var(--font-sans-serif);
  font-size: 18px;
  /* margin-top: 15px; */
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
    transition: all 0.25s ease;
  }
`

export default MainButton
